import { FC, useEffect, useState } from "react";
import StepInfo from "pages/StepPages/components";
import { Search } from "components-new";
import Row from "./Row";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { useLocation, useParams } from "react-router-dom";
import { getOkiiStatuses } from "toolkit/organizations/organizations.thunks";
import { ReactComponent as InfoIcon } from "images/infoIcon.svg";
import useDebounce from "hooks/useDebounce";
import Tooltip from "components-new/Tooltip";
import cn from "classnames";
import styles from "./StatusOkii.module.sass";

const StatusOkii: FC = () => {
	const dispatch = useAppDispatch();
	const location = useLocation();

	const [searchValue, setSearchValue] = useState<string>("");
	const debouncedSearchValue = useDebounce(searchValue, 400);

	const { organizationId } = useParams();
	const { statusesOkii } = useAppSelector((state) => state.organizations);

	useEffect(() => {
		dispatch(getOkiiStatuses({ orgId: organizationId, query: searchValue }));
		//eslint-disable-next-line
	}, [debouncedSearchValue]);

	return (
		<div className="step-wrapper">
			<div className="step-header">
				<StepInfo info="Просмотр статуса ОКИИ" companyName={location.state?.organizationName} stepTitle="" />
				<Search
					className={styles.search}
					searchValue={searchValue}
					handleSearch={(e) => setSearchValue(e.target.value)}
					placeholder="Найти объект"
				/>
			</div>
			<div className={styles.legends}>
				<span className={styles.text}>Легенда:</span>
				<div className={styles.legendsItem}>
					<div className={cn(styles.circle, styles.white)} />
					<div className={styles.textItem}>Категорирование не начато</div>
				</div>
				<div className={styles.legendsItem}>
					<div className={cn(styles.circle, styles.orange)} />
					<div className={styles.textItem}>Категорирование в процессе</div>
				</div>
				<div className={styles.legendsItem}>
					<div className={cn(styles.circle, styles.green)} />
					<div className={styles.textItem}>Завершено</div>
				</div>
				<div className={styles.legendsItem}>
					<div className={cn(styles.circle, styles.purple)} />
					<div className={styles.textItem}>Повторное категорирование</div>
				</div>
			</div>
			<div>
				<div className={styles.tableHead}>
					<div>Объект</div>
					<div>Реестровый номер ФСТЭК</div>
					<div>Дата планового категорирования</div>
					<div>Категория значимости</div>
					<div className={styles.information}>
						<Tooltip
							color="themeWhite"
							position="top-left"
							menu={
								<div className={styles.popup}>
									В столбце указана дата прохождения процесса подбора категории для объекта на шаге 5
								</div>
							}>
							<InfoIcon className={styles.infoIcon} />
						</Tooltip>
						<span>Дата присвоения категории</span>
					</div>
					<div></div>
				</div>
				<div className={styles.tableBody}>
					{statusesOkii.map((okiiStatus) => (
						<Row key={okiiStatus.id} row={okiiStatus} />
					))}
				</div>
			</div>
		</div>
	);
};

export default StatusOkii;
